import React from 'react';
import { gettext } from '@eb/i18n';
import { FALLBACK_SUGGESTIONS } from '@eb/site-header';
import { InputField } from '@eb/eds-input-field';
import { Icon } from '@eb/eds-icon';
import { Button } from '@eb/eds-button';
import { MagnifyingGlassChunky } from '@eb/eds-iconography';

import './GlobalHeaderSearch.scss';

export const getSearchInfo = (
    serverUrl,
    query,
    suggestions = FALLBACK_SUGGESTIONS,
) => {
    return {
        formAction: `${serverUrl}/d/`,
        label: gettext('Search'),
        query,
        suggestions,
    };
};

const GlobalHeaderSearch = ({
    searchInfo,
    setRenderSearchTakeover,
    containerClassName = 'consumer-header__search',
}) => {
    if (!searchInfo) {
        return null;
    }

    return (
        <div className={containerClassName} data-spec="consumer-header-search">
            <Button
                onClick={() => setRenderSearchTakeover(true)}
                style="none"
                size="block"
                data-testid="consumer-global-header-search"
                __containerClassName="consumer-header__search--button"
            >
                <InputField
                    disabled={true}
                    label={gettext('Search for events')}
                    id="header-event-search-button"
                    style="basic"
                    placeholder={gettext('Search events')}
                    prefix={
                        <Icon color="ui-600" type={<MagnifyingGlassChunky />} />
                    }
                />
            </Button>
        </div>
    );
};

export default GlobalHeaderSearch;
